import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { BookingIdDetailsApi } from '../../services/Api';
import { isAdmin, isAuthenticated } from '../../services/Auth';

export default function BookingIdDetails() {

    const [booking, setBooking] = useState();
    const { id } = useParams();

    useEffect(() => {
        if (isAuthenticated() && isAdmin()) {
            BookingIdDetailsApi(id).then((response) => {
                setBooking(response.data.booking)
            })
        }
    }, [id])

    if (!isAuthenticated() || !isAdmin()) {
        return <Navigate to="/login" />
    }


    return (booking &&
        <>
            <div className="container-fluid p-2">
                <div className='m-lg-5'>
                    <div className='m-lg-5'>
                        <div className='m-sm-5 border border-5 p-3'>
                            <h4 className='text-center text-decoration-underline m-1'>Booking ID #{booking._id}</h4>
                            <div><span className='fw-medium'>Booking Status : </span>{booking.status}</div>
                            <div><span className='fw-medium'>Name : </span>{booking.fullName}</div>
                            <div><span className='fw-medium'>Address : </span>{booking.address}</div>
                            <div><span className='fw-medium'>Phone Number : </span>{booking.pno}</div>
                            <div><span className='fw-medium'>Email Address : </span>{booking.email}</div>
                            <div><span className='fw-medium'>Date : </span>{booking.createdAt}</div>
                            <div><span className='fw-medium'>Total Amount : </span>{booking.amount} Rs</div>
                            <h5 className='text-center text-decoration-underline m-1'>Booking Room Varient(s)</h5>
                            <div className="booking-slot-item my-1">
                                    {booking.bookingSlotItems && booking.bookingSlotItems.map(item => (
                                        <div key={item.room._id}>
                                            <hr />
                                            <div className="bookingSlot-item">
                                                <div className="row">
                                                    <div className="col-6 col-lg-3 text-center">
                                                        <Link to={"/room/" + item.room._id}>
                                                            <img src={item.room.images[0].image} alt={item.room.name} height="110" width="140" />
                                                        </Link>
                                                    </div>

                                                    <div className='col-6 col-lg-9'>
                                                        <div className="row d-flex flex-column flex-lg-row justify-content-center align-items-center">
                                                            <h6 className="col text-center m-2">
                                                                <Link className='text-black' to={"/room/" + item.room._id} >{item.room.name}</Link>
                                                            </h6>

                                                            <div className="col text-center m-2">
                                                                <div>
                                                                    <h6>CheckIn</h6>
                                                                    <h6 className='fw-bolder'>{item.checkIn}</h6>
                                                                </div>
                                                                <hr />
                                                                <div>
                                                                    <h6>Days</h6>
                                                                    <h6 className='fw-bolder'>{item.days}</h6>
                                                                </div>
                                                            </div>

                                                            <div className="col text-center m-2">
                                                                <h6>Rooms</h6>
                                                                <h6>{item.qty}</h6>
                                                            </div>

                                                            <div className="col text-center m-3">
                                                                <h6>Varient Total</h6>
                                                                <h5>Rs. {item.room.price * item.days * item.qty}</h5>
                                                                {/* <span onClick={() => removeItem(item)}><i className="fa fa-trash btn btn-danger"></i></span> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            <hr />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}